module.exports = __webpack_public_path__ + "img/pra-logo-portal-parana-acessivel.e457a01c.png";